import { render, staticRenderFns } from "./Edit-national-campaign.vue?vue&type=template&id=13ed8f38&"
import script from "./Edit-national-campaign.vue?vue&type=script&lang=js&"
export * from "./Edit-national-campaign.vue?vue&type=script&lang=js&"
import style0 from "./Edit-national-campaign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports